import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { getAppStore } from '~src/app/AppStore';
import { siteUrlsSelector } from '~src/app/selectors/SiteUrlsSelectors';

import { ConnectedApplicationDetailsSubspace } from './ConnectedApplicationDetailsSubspace';
import { ConnectedApplicationSettingSubspace } from './ConnectedApplicationSettingsSubspace';

// Not in it's own file because it simply routes to the main component (above) or to sub-subsapces
export function ConnectedApplicationSubspaceRouter() {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  return <Switch>
    <Route exact path={siteUrls.settingsConnectedApplicationsPath()} render={({ location }) => {
      return <ConnectedApplicationSettingSubspace {...location} />;
    }} />
    <Route exact path={siteUrls.connectedApplicationPath(':id')} render={({ match }) => {
      return <ConnectedApplicationDetailsSubspace {...match} />;
    }} />
  </Switch>;
}